// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2787e5dfdf--wrapper--ajvzg","icon":"_2787e5dfdf--icon--kKg0q","title":"_2787e5dfdf--title--h_ZlQ","message":"_2787e5dfdf--message--B6XL3"};